import actionTypes, * as actionObjects from 'projects-new/new-list/action-types'
import { deleteList as deleteListAC } from "projects-new/issue-management/action-types"
import * as djangioActionCreators from 'shared/djangio/action-creators'
import { clearSavedSearch } from 'alerts/action-creators'
import { ALERT_FORM_KEY } from 'shared/imports/sharedConstants'
import { segue, destroyReduxForm } from 'global-action-creators'

import * as listAdderActionCreators from 'shared/profiles/listAdder/action-creators'

export const removeListItem = listAdderActionCreators.removeListItem
export const addListItem = listAdderActionCreators.addListItem

/**
 * take in api responses, and sets them as lists on the newList slice of the store
 * loadLists expects a many resource response, meaning list resources are under response.objects, while
 * loadList expects a single resource response, meaning list resource is under response
 * @name loadLists, loadList
 * @function
 * @param {obj} - response - the response of a get request to newList endpoitn
*/
export const loadLists = response => ({ type: actionTypes.loadLists, lists: response.objects })
export const loadList = response => ({ type: actionTypes.loadList, list: response })

/**
 * Sends a request to patch a newlist with locked true|false
 * @name lockList, unlockList
 * @function
 * All params are named params being passed via an obj as the first argument
 * @param {number} - id - id for the list
*/
export const lockList = ({ id }) =>
    djangioActionCreators.resourcePatchDetail(
        DjangIO.app.userdata.models.NewList,
        actionObjects.lockList,
        id,
        { locked: true },
        { id }
    )
export const unlockList = ({ id }) =>
    djangioActionCreators.resourcePatchDetail(
        DjangIO.app.userdata.models.NewList,
        actionObjects.unlockList,
        id,
        { locked: false },
        { id }
    )

/**
 * Sends an action request to convert the list to static (remove savedSearch filters and add results to added_ids)
 * @name unAutoList
 * @function
 * All params are named params being passed via an obj as the first argument
 * @param {number} - id - id for the list
*/
export const unAutoList = ({ id }) =>
    djangioActionCreators.sendAction(
        DjangIO.app.userdata.models.NewList.objects.get(id),
        actionObjects.unAutoList,
        {
            action: 'convert_to_static',
            method: 'patch',
            payload: { id }
        }
    )

/**
 * Cleans up then send user to alert form with the list's saved search prepopulated
 * @name createAlert
 * @function
 * All params are named params being passed via an obj as the first argument
 * @param {string} - name - name of the list
 * @param {string} - savedSearch - uri to the related saved_search
*/
export const createAlert = ({ name, savedSearch }) =>
    async dispatch => {
        // clean up the store for segue to this form with a new saved search
        await dispatch(clearSavedSearch())
        await dispatch(destroyReduxForm(ALERT_FORM_KEY))

        const encodedName = encodeURIComponent(name)
        const savedSearchId = DjangIO.app.userdata.models.SafedSearch.idFromResourceUri(savedSearch)
        const url = `/alert/search/${savedSearchId}/list/?name=${encodedName}`
        return dispatch(segue(url))
    }

/**
 * Sends a patch request to rename the list
 * @name renameList
 * @function
 * All params are named params being passed via an obj as the first argument
 * @param {string} - oldName - the current name of the list, used to rollback the store if request fails
 * @param {string} - newName - the wanted new name for the list
 * @param {number} - id - id of the list
*/
export const renameList = ({ id, newName, oldName }) =>
    djangioActionCreators.resourcePatchDetail(
        DjangIO.app.userdata.models.NewList,
        actionObjects.renameList,
        id,
        { name: newName },
        { newName, oldName, id }
    )

/**
 * Sends a patch request to update the project associated with the list
 * this uses the deleteList actionObject, as in the perspective of the issue, it is the same as deleting it
 * @name moveList
 * @function
 * All params are named params being passed via an obj as the first argument
 * @param {number} - destinationIssueId - the id of the project this list is moving to
 * @param {number} - currentIssueId - the id of the project this list is moving from (used for store logic)
 * @param {number} - id - the list id
*/
export const moveList = ({ id, destinationIssueId, currentIssueId }) =>
    djangioActionCreators.resourcePatchDetail(
        DjangIO.app.userdata.models.NewList,
        deleteListAC,
        id,
        { project: DjangIO.app.userdata.models.IssueManagement.resourceUriFromId(destinationIssueId) },
        { issueId: currentIssueId, listId: id }
    )
